var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(-566 -573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M323.48,419.332h0a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24h0a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24Z",
    transform: "translate(242.52 177.668)",
    fill: "#71af47",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(578 585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M7.05,14.121,4.93,16.243l2.828,2.828L19.071,7.757,16.243,4.93,14.12,7.05l1.415,1.414L14.12,9.88,12.706,8.465,11.292,9.88l1.414,1.414-1.414,1.414L9.878,11.294,8.463,12.708l1.415,1.414L8.463,15.537,7.05,14.12Zm9.9-11.313L21.192,7.05a1,1,0,0,1,0,1.414L8.464,21.192a1,1,0,0,1-1.414,0L2.808,16.95a1,1,0,0,1,0-1.414L15.536,2.808A1,1,0,0,1,16.95,2.808ZM14.12,18.363l1.415-1.414,2.242,2.243h1.414V17.778l-2.242-2.243,1.414-1.414L21,16.757V21H16.758l-2.637-2.637ZM5.636,9.878,2.807,7.05a1,1,0,0,1,0-1.415L5.636,2.807a1,1,0,0,1,1.414,0L9.88,5.635,8.464,7.05,6.343,4.928,4.929,6.343,7.05,8.463,5.636,9.878Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.b839218da2d827651b0c7e574ed5b6c3.svg";
export { ForwardRef as ReactComponent };